module.exports = __webpack_public_path__ + "img/living_icon.1ca018a4.jpg";